import Vue from 'vue'
import Router from 'vue-router'

import AppView from '@/views/layout/app-view'
import Home from '@/views/home'

Vue.use(Router)

const page = name => () => import('@/views/' + name)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      component: AppView,
      children: [
        {path: '/', name: 'home', component: Home, redirect: {path: '/meeting/order'}},
        {path: '/meeting/order', name: 'meetingorder', component: page('meeting/index')},
        {path: '/meeting/detail/:id', name: 'meetingdetail', component: page('meeting/detail')},
      ]
    },
    {
      path: '',
      component: AppView,
      children: [
        {path: '/monitor/list', name: 'monitorlist', component: page('monitor/index')},
      ]
    },
    {
      path: '',
      component: AppView,
      children: [
        // {path: '/corder/list', name: 'corder', component: page('corder/index')},
        {path: '/ordertpl/list', name: 'ordertpl', component: page('ordertpl/index')},
        {path: '/workorder/create/:id', name: 'createorder', component: page('createorder/index')},
        {path: '/suborder/modify/:id', name: 'modifyorder', component: page('modifyorder/index')},
        {path: '/submitted/order', name: 'submitted', component: page('submitorder/index')},
        {path: '/suborder/approve/:id', name: 'suborder', component: page('suborder/index')},
        {path: '/suborder/log/:id', name: 'suborderlog', component: page('suborder/log')},
        {path: '/user/info', name: 'userinfo', component: page('userinfo/index')},
      ]
    },
    {
      path: '',
      component: AppView,
      children: [
        {path: 'manage/submitted/order', name: 'managesubmitted', component: page('managesubmitorder/index')},
        {path: 'manage/flowconf', name: 'manageflowconf', component: page('manageflowconf/index')},
        {path: 'manage/flowroleconf/:id', name: 'manageflowroleconf', component: page('manageflowroleconf/add')},
        {path: 'manage/flowroleconfmodify/:id', name: 'manageflowroleconfmodify', component: page('manageflowroleconf/add')},
        {path: 'manage/flowroleconf/list/:id', name: 'manageflowroleconflist', component: page('manageflowroleconf/index')},
      ]
    },

    {path: '/login', name: 'login', component: page('login')},
    {path: '/mb/meeting/order', name: 'mbmeetingorder', component: page('mb/meeting/index')},
    {path: '/mb/meeting/detail/:id', name: 'mbmeetingdetail', component: page('mb/meeting/detail')},
    {path: '/mb/suborder/approve/:id',name: 'mbsuborder',component: page('mb/suborder/index')},
    {path: '/mb/user/info', name: 'profile', component: page('mb/profile/index')},
    {path: '/templates', name: 'templates', component: page('ordertpl/index2')},
    // pages
    {path: '*', redirect: {name: '404'}}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js